import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cart",
  "use": "cart-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol viewBox=\"0 0 25 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"cart\"><path d=\"M22.479 7.431A1 1 0 0 0 21.657 7H7.99L6.836 4.23A1.994 1.994 0 0 0 4.99 3H2.657v2H4.99l4.744 11.385a1 1 0 0 0 .923.615h8c.417 0 .79-.259.937-.648l3-8a1 1 0 0 0-.115-.921ZM11.157 21a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM18.157 21a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol